export default "__VITE_ASSET__BJQV8LeH__"